import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import {log, logModel} from "../../model/logsModel"
import * as moment from 'moment';
import {personModel, statsRecord} from "../../model/personModel"

@Component({
    selector: 'timeline',
    templateUrl: 'Timeline.html'
})
export class TimelinePage {
    events: any;
    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        public logModel: logModel,
        public statsRecord: statsRecord
    ) {
    }
}


// WEBPACK FOOTER //
// ./src/pages/Timeline/Timeline.ts